export const experiences = [
  {
    time: "Oct 2023 - Dec 2025",
    title: "Senior Software Engineer",
    company: "YOYA Technologies Limited",
    resposibility: [
      "Spearheaded development and integration of an arrears penalty module into the IRAS revenue system, ensuring seamless compatibility with existing services.",
      "Automated the presumptive tax payment workflow in IRAS, improving processing efficiency by 40%.",
      "Built the Tayari Loans MVP (React/TypeScript) with payments, transactions, and reporting features; delivered 3 months ahead of schedule.",
      "Built the NARO Revenue Collection System (React/TypeScript) with payments, transactions, and reporting features.",
      "Developed and shipped multiple NEMA eServices modules (permits, licensing, ozone platform) in collaboration with cross-functional teams.",
      "Optimized file handling in the IRAS Mobile App, improving stability and performance for end users.",
    ],
  },
  {
    time: "Aug 2023 - Sep 2025",
    title: "Technical Lead",
    company: "Cranecloud",
    resposibility: [
      "Led a team of 7 engineers across backend, frontend, and DevOps initiatives spanning multiple services and customer deployments.",
      "Drove the transition to a Kubernetes-based microservices architecture, improving scalability, maintainability, and fault isolation.",
      "Implemented real-time logging and observability, cutting debugging time by 70% and improving incident response.",
      "Standardized containerization and DevOps automation for React/Django/Flask services, reducing deployment time by 67%.",
      "Designed and delivered a modernized UI (React/TypeScript/Vite/Mantine), increasing interaction and task efficiency by 35%.",
      "Mentored engineers through code reviews, documentation, and sprint retrospectives, raising overall delivery quality.",
    ],
  },

  {
    time: "Mar 2019 - Jul 2023",
    title: "Software Engineer",
    company: "Cranecloud",
    resposibility: [
      "Developed and maintained core backend services in Python (Flask/Django) and improved reliability through instrumentation and monitoring.",
      "Integrated metrics and monitoring (Prometheus) to support performance tracking and capacity planning.",
      "Built automated containerization templates and pipelines for common frameworks (React.js, Django, Flask, PHP), improving developer onboarding and consistency.",
      "Contributed to Kubernetes and Docker-based infrastructure for app deployment and lifecycle management.",
    ],
  },

  {
    time: "Mar 2023 - Jul 2023",
    title: "Software Engineer (Contract)",
    company: "Harmonic AI",
    resposibility: [
      "Delivered advanced sorting features in the Harmonic Console (React/TypeScript), improving data retrieval relevance and accuracy by 95%.",
      "Improved data accuracy in the Chrome Extension, reducing user-reported errors by 60%.",
      "Added headcount visualizations to company pages, strengthening analytical insights and product decision-making.",
      "Migrated 10+ pipelines from Cloud Tasks to Pub/Sub, reducing operational cost by 30% and improving throughput.",
    ],
  },
  {
    time: "Apr 2021 - Mar 2023",
    title: "Full Stack Developer",
    company: "Ziramba",
    resposibility: [
      "Designed and built a robust e-commerce platform (React/Django) with FlutterWave payment integration.",
      "Created 100+ automated tests and achieved 80% backend test coverage, reducing regression bugs by 60%.",
      "Architected CI/CD pipelines using Docker and docker-compose, cutting deployment time by 40% and standardizing environments across dev/stage/prod.",
      "Integrated Firebase Firestore for file hosting, reducing storage costs by 25% while improving accessibility.",
    ],
  },

  {
    time: "Aug 2022 - Nov 2022",
    title: "Frontend Developer (Freelancer)",
    company: "Mkoba",
    resposibility: [
      "Built a comprehensive React.js admin dashboard for a fintech platform, improving maintainability with hooks and context.",
      "Delivered real-time data visualization and API integrations for 50+ metrics, supporting operational decision-making.",
      "Implemented advanced form handling and collaborated with backend engineers on clean, scalable REST API design.",
      "Partnered with UX to deliver an intuitive, responsive experience for multiple stakeholder groups.",
    ],
  },
  {
    time: "Jun 2022 - Dec 2022",
    title: "Frontend Engineer (Contract)",
    company: "Term Payments",
    resposibility: [
      "Led React Native frontend development for iOS and Android, enabling in-person payments for online purchases at local stores.",
      "Integrated QR scanning, push notifications, and Google Maps, increasing user retention by 35%.",
      "Collaborated closely with designers on UI/UX decisions and mockups to deliver a polished, production-ready experience.",
    ],
  },
  {
    time: "Nov 2020 - July 2021",
    title: "Software Engineer",
    company: "Waape",
    resposibility: [
      "Contributed to building Waape (waape.io), a platform connecting job seekers to job creators.",
      "Helped deliver the Freelancer platform end-to-end in 6 months, including onboarding, profiles, and core marketplace flows (Bubble).",
      "Integrated geolocation features and Twilio notifications to improve communication and engagement.",
    ],
  },
  {
    time: "Jun 2020 - Jan 2021",
    title: "Fullstack Web Developer",
    company: "Matatu Hub",
    resposibility: [
      "Architected and developed the Mobile Shop e-commerce platform (mobileshop.ug), ensuring scalable integration between frontend and backend services.",
      "Built a responsive React.js web client from Figma wireframes, improving cross-device experience and usability.",
      "Developed a Python Flask REST API, deployed on Heroku with PostgreSQL for core data management.",
      "Mentored junior developers and supported delivery planning to improve execution and code quality.",
    ],
  },
];

export const learning = [
  {
    time: "2016 - 2020",
    title: "Makerere University",
    company: "Makerere University",
    resposibility: ["Bachelor of Science in Computer Science"],
  },
];

export const skills = [
  {
    name: "JavaScript",
    percentage: 91,
  },
  {
    name: "TypeScript",
    percentage: 88,
  },
  {
    name: "Python",
    percentage: 90,
  },
  {
    name: "React.js",
    percentage: 89,
  },
  {
    name: "Next.js",
    percentage: 78,
  },
  {
    name: "Flask",
    percentage: 80,
  },
  {
    name: "React Native",
    percentage: 70,
  },
  {
    name: "Django",
    percentage: 80,
  },
  {
    name: "Docker",
    percentage: 85,
  },
  {
    name: "Kubernetes",
    percentage: 80,
  },
  {
    name: "CI/CD",
    percentage: 80,
  },
  {
    name: "Microservices",
    percentage: 78,
  },
  {
    name: "PostgreSQL",
    percentage: 72,
  },
  {
    name: "MySQL",
    percentage: 70,
  },
  {
    name: "MongoDB",
    percentage: 62,
  },
  {
    name: "SQL",
    percentage: 70,
  },
  {
    name: "Tailwind CSS",
    percentage: 75,
  },
  {
    name: "Mantine",
    percentage: 72,
  },
  {
    name: "Vite",
    percentage: 78,
  },
  {
    name: "Figma",
    percentage: 70,
  },
  {
    name: "MLflow",
    percentage: 60,
  },
];

export const portfolios = [
  {
    title: "IRAS",
    image: "iras.png",
    url: "https://iras.go.ug/",
    info: "Uganda’s digital platform for managing tax collection and revenue workflows.",
  },
  {
    title: "Nema eServices",
    image: "nema.png",
    url: "https://eservices.nema.go.ug",
    info: "A secure eServices platform for NEMA to manage permits, licensing, and compliance operations.",
  },
  {
    title: "Harmonic AI",
    image: "harmonic.png",
    url: "https://harmonic.ai",
    info: "Provides a comprehensive database for discovering startups and emerging companies.",
  },
  {
    title: "Crane cloud",
    image: "cranecloud.png",
    url: "https://cranecloud.io",
    info: "A cloud Platform-as-a-Service (PaaS) for deploying and managing applications and databases at scale.",
  },
  {
    title: "Tayari",
    image: "tayari.png",
    url: "https://tayari.yoyaloans.net/",
    info: "A loan management platform for tracking financed assets, payments, and field operations.",
  },
  {
    title: "NARO",
    image: "naro.png",
    url: "https://naro.go.ug/",
    info: "A revenue collection system for the National Agricultural Research Organisation(NARO).",
  },
  {
    title: "Ziramba",
    image: "ziramba.png",
    url: "https://ziramba.com",
    info: "An e-commerce platform for construction materials with payments and order tracking.",
  },
  {
    title: "Waape",
    image: "waape.png",
    url: "https://www.waape.ug",
    info: "A hiring marketplace connecting job seekers with job creators and opportunities.",
  },
  {
    title: "Mobile Shop",
    image: "mobileshop.png",
    url: "https://mobileshop.ug",
    info: "An e-commerce platform for electronics with a modern responsive shopping experience.",
  },
  {
    title: "Infinity Comics",
    image: "infinity.png",
    url: "https://infinitycomics.tv",
    info: "A content provider showcasing African stories and shows for a global audience.",
  },
];

export const cerfificates = [
  {
    name: "Python Data Structures",
    issuing_organisation: "Coursera",
    image: "data_structures_cert.png",
    issue_date: "September 2020",
    credential_url:
      "https://www.coursera.org/account/accomplishments/certificate/FEQSREM526PE",
    credential_id: "FEQSREM526PE",
  },
  {
    name: "Google Cloud Platform Fundamentals: Core Infrastructure",
    issuing_organisation: "Coursera",
    image: "gcp_cert.png",
    issue_date: "August 2020",
    credential_url:
      "https://www.coursera.org/account/accomplishments/certificate/S7Z4733VG2CG",
    credential_id: "S7Z4733VG2CG",
  },
  {
    name: "Architecting with Google Kubernetes Engine: Foundations",
    issuing_organisation: "Coursera",
    image: "kubernetes_cert.png",
    issue_date: "August 2020",
    credential_url:
      "https://www.coursera.org/account/accomplishments/certificate/Y3BMNVCBKRGB",
    credential_id: "Y3BMNVCBKRGB",
  },
  {
    name: "Technical Support Fundamentals",
    issuing_organisation: "Coursera",
    image: "tech_support.png",
    issue_date: "August 2020",
    credential_url:
      "https://www.coursera.org/account/accomplishments/certificate/Y6KPHEHRJTEG",
    credential_id: "Y6KPHEHRJTEG",
  },
];
